import React from 'react';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import GitHubIcon from '@mui/icons-material/GitHub';
function Contact() {
  return (
    <div>
      <div className="second2-img">
        <img src="./assests/social.jpg" alt="link1.jpg" />
      </div>
      <div className="para2">
        <p>
          I am available on almost every social media. You can message me; I will reply within 24 hours.
          I can help you with ML, AI, React, Android, Cloud, and Opensource Development.
        </p>
      </div>
      
      <div className='social'>
 <a className='linkedin' aria-label='Linkedin' href='https://www.linkedin.com/in/coder-varun-walia/' target='blank'><LinkedInIcon/></a>
<a className='instagram' aria-label='Instagram' href='https://www.instagram.com/pb39hyper/' target='blank'><InstagramIcon/></a>
<a className='youtube' aria-label='Youtube' href='https://www.youtube.com/@pb39Hyepr' target='blank'><YouTubeIcon/></a>
<a className='github' aria-label='Github' href='https://github.com/varunwalia09' target='blank'><GitHubIcon/></a>
</div>
{/* <div className="second3-img">
        <img src="./assests/gaming.jpg" alt="gaming.jpg" />
      </div> */}
      <div className="para2">
        <p>For individual fundamental empowerment, I like to make powerful video lessons that 
      create impact on each of the reader individually to change the core of their character and their carrer development.</p>
      </div>
<div className='social'>
<b><a className='youtube' aria-label='Youtube' href='https://www.youtube.com/@pb39Hyepr' target='blank' class="flex items-center justify-center bg-orange-500 text-black rounded-full px-4 py-2">Visit My Gaming Channel</a></b>
</div>
    </div>
  );
}

export default Contact;

